import { useMemo } from 'react';

export const useIsMobileWebview = () =>
  useMemo(() => window.navigator.userAgent.indexOf('circles-mobile-app') > -1, []);
